import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { authActions } from "../_store";
import { getStoredValue, setStoredValue } from "../_helpers/storagehelper";
import axios from "axios";

const useIPAddress = () => {
  const [ip, setIp] = useState(getStoredValue("cachedIP") || "");
  const dispatch = useDispatch();

  useEffect(() => {
    const GetIPAddress = () => {
      const cachedIP = getStoredValue("cachedIP");
      if (cachedIP) {
        setIp(cachedIP);
      }
      axios.get("https://api.ipify.org?format=json").then((IPAddress) => {
        IPAddress?.status === 200 &&
          IPAddress?.data?.ip &&
          setStoredValue("cachedIP", IPAddress?.data?.ip);
        setIp(IPAddress?.data?.ip);
      });

      // dispatch(authActions.GetIPAddress()).then((x) => {
      //   if (x?.payload?.IpAddress) {
      //     setStoredValue("cachedIP", x.payload.IpAddress);
      //     setIp(x?.payload?.IpAddress);
      //   }
      // });
    };

    GetIPAddress();
  }, [dispatch]);

  return ip;
};

export default useIPAddress;
